import { getFrameworkDataSchemasClient } from 'framework-data-schema-resolvers';
import { COLLABORATION_SIDEBAR_FAS_NAMESPACE, COMMENTING_FAS_NAMESPACE } from './constants';
export function getFrameworkAppSettings({
  isUngatedForFASCommenting
}) {
  return getFrameworkDataSchemasClient().then(client => client.typeMetadata.get({
    appSettingNames: isUngatedForFASCommenting ? [COLLABORATION_SIDEBAR_FAS_NAMESPACE, COMMENTING_FAS_NAMESPACE] : [COLLABORATION_SIDEBAR_FAS_NAMESPACE]
  })).catch(() => null);
}